export const INCENTIVES = "Incentive";
export const REPORTS = "Reports";
export const DATA = "Data";
export const DASHBOARD = "Dashboard";
export const CASHOUT_LIMIT = "Cash Out Limit";

export const VALIDATIONS = "Validations";
export const PAYOUT = "Payouts";
export const ON_HOLD = "On-Hold";
export const EXCLUSION = "Exclusions";
export const FORMULAS = "Formulas";

export const CONTACTS = "Contacts";
export const INVOICES = "Invoices";
export const FORMS = "Forms";
export const PAYOUT_DATES = "Payout Dates";
export const FREEZE_ACCOUNT = "Freeze Account";
export const CREDIT_DEBIT = "Debit / Credit ";
export const ADJUSTMENT = "Adjustment";
export const EARMARK = "Earmark";

export const WITHOLDING_TAX = "Withholding Tax";

export const CLUSTERS = "Clusters";
export const ROLES = "Roles";
export const HIERARCHY = "Hierarchy";
export const MODULES = "Modules";
export const USERS = "Users";
export const REQUEST = "Request";
export const ROLE_LOG = "Log";


export const MANAGE_TEAM = "Manage Team";
export const CONTACT_INFORMATIONS = "Contact Informations";

export const INVOICE_BALANCE = "Invoice Balance";

// Login Box
export const SUCCESS = "Success";

export const ALERT = "Alert";
export const ERROR = "Error";
export const SOME_ERROR_OCCURRED = "Some Error Occurred, Please try again!";
export const NO_INTERNET_CONNECTION_FOUND = "No Internet Connection Found!";
export const YOU_ARE_ONLINE = "You are online.";
export const YOU_ARE_OFFLINE = "You are offline!";

export const PROCESSING_PLEASE_WAIT = "Processing , please wait...";
export const FETCHING_PAYOUT_DETAILS_PLEASE_WAIT =
  "Loading Payout Details , please wait...";
export const FETCHING_PAYOUT_SUMMARY_PLEASE_WAIT =
  "Loading Payout Summary , please wait...";
export const LOADING_TIMELINE = "Loading timeline...";
export const LOADING_ACTIVITY_DETAILS = "Loading activity details...";

export const FETCHING_ON_HOLD_SUMMARY_PLEASE_WAIT =
  "Loading On Hold Summary , please wait...";

export const LOADING_PLEASE_WAIT = "Loading , please wait...";
export const LOADING_REPORT_NAMES_PLEASE_WAIT = "Loading report names , please wait...";
export const LOADING_CONFIGRATION_PLEASE_WAIT =
  "Loading configration, please wait...";
export const AUTHENTICATING_PLEASE_WAIT = "Authenticating, please wait...";
export const DOWNLOADING_REPORT = "Downloading report...";
export const ERROR_WHILE_AUTHENTICATING_USER =
  "Error while authenticating user - ";
export const ERROR_WHILE_RETRIEVING_BASIC_AUTH =
  "Error while retrieving basic auth: ";
export const ERROR_WHILE_FETCHING_PAYOUT_DETAILS =
  "Error while fetching payout details: ";
export const ERROR_FOUND_DURING_API_CALL = "An Error Occurred: ";
export const ERROR_WHILE_FETCHING_DATA = "";

export const DONT_HAVE_A_ACCOUNT_SIGNUP = "Don't have an account? Sign Up";
export const FORGOT_PASSWORD = "Forgot Password";
export const FORGOT_USERNAME = "Forgot Username";
export const REMEMBER_ME = "Remember me";

// Dashboard
export const NO_RECORD_FOUND = "No Record Found";

// Add Earmark
export const ADDING_EARMARK = "Adding Earmark";

// Common
export const LOADING_FILTER_DETAILS_PLEASE_WAIT = "Loading Filter Details...";
